import React, {ReactElement} from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import {Cards} from "../../components/Cards/Cards"
import {useIsOrgUser, useIsUnitUser} from "../../services/auth"
import {CardsColumns} from "../../components/Cards/Cards.types"

export function CardsPage(): ReactElement {
	const isUnitUser = useIsUnitUser()
	const isOrgUser = useIsOrgUser()
	const showOrgBankFields = isUnitUser && !isOrgUser

	return (
		<>
			<TitleBar title={"Cards"} />

			<MainSectionTable>
				<Cards
					enableOrgFilter={showOrgBankFields}
					enableBankFilter={showOrgBankFields}
					enableCardTypeFilter
					enableStatusFilter
					enableSearch
					enableTitle={false}
					limit={40}
					fullHeight={true}
					includedColumns={[
						CardsColumns.id,
						CardsColumns.last4Digits,
						CardsColumns.cardHolder,
						CardsColumns.expiration,
						CardsColumns.status,
						...(showOrgBankFields ? [CardsColumns.bank] : []),
						...(showOrgBankFields ? [CardsColumns.org] : []),
						// ADD CUSTOMER
						CardsColumns.accountId,
						CardsColumns.cardType,
						CardsColumns.createdAt,
						CardsColumns.updatedAt,
						CardsColumns.actions,
					]}
				/>
			</MainSectionTable>
		</>
	)
}
